var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "c--customer-reviews_item",
    class: `${_vm.classPrefix}-box review-item`,
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap",
    attrs: {
      "header-tag": "div"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center mb-2 mb-md-0"
  }, [_c('raiting', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "value": _vm.item.rating,
      "width": 22,
      "color": ['#FBB034', '#FFCC00'],
      "unrated-color": ['#DDDDDD', '#DDDDDD']
    }
  }), _vm._v(" "), _c('country-name-in-flag', {
    class: {
      'ml-0 ml-md-2': _vm.$dir() === 'ltr',
      'mr-0 mr-md-2': _vm.$dir() === 'rtl'
    },
    attrs: {
      "country-flag-url": _vm.item.country.image.url,
      "country-flag-width": 29,
      "country-name": _vm.item.country.title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-start align-items-center"
  }, [_c('header-right', {
    attrs: {
      "reviewer": _vm.item.customer_name
    }
  })], 1)]), _vm._v(" "), _c('b-card-body', [_c('div', {
    staticClass: "d-flex justify-content-start align-items-start w-full flex-col flex-wrap"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('h3-title', {
    class: {
      'one-line-text': _vm.textCollapsed
    },
    attrs: {
      "title": _vm.item.title
    }
  })], 1), _vm._v(" "), _c('div', [_c('less-more-text', {
    attrs: {
      "text": _vm.item.content,
      "button-more-text": _vm.$t('components.customer.reviews.more-button'),
      "button-less-text": _vm.$t('components.customer.reviews.less-button'),
      "close": _vm.closeLessMore,
      "is-less-more-prevent": _vm.isLessMorePrevent
    },
    on: {
      "changeCollapse": _vm.changeCollapse
    }
  })], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }